import * as React from "react"
import { cn } from "@/lib/utils"

const GradientText = React.forwardRef(
  ({ className, as: Component = "h1", children, ...props }, ref) => (
    <Component
      ref={ref}
      className={cn(
        "font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent",
        className
      )}
      {...props}
    >
      {children}
    </Component>
  )
)
GradientText.displayName = "GradientText"

// Preset sizes for common heading levels
const GradientH1 = React.forwardRef(({ className, ...props }, ref) => (
  <GradientText
    ref={ref}
    as="h1"
    className={cn("text-4xl", className)}
    {...props}
  />
))
GradientH1.displayName = "GradientH1"

const GradientH2 = React.forwardRef(({ className, ...props }, ref) => (
  <GradientText
    ref={ref}
    as="h2"
    className={cn("text-3xl", className)}
    {...props}
  />
))
GradientH2.displayName = "GradientH2"

const GradientH3 = React.forwardRef(({ className, ...props }, ref) => (
  <GradientText
    ref={ref}
    as="h3"
    className={cn("text-2xl", className)}
    {...props}
  />
))
GradientH3.displayName = "GradientH3"

const GradientH4 = React.forwardRef(({ className, ...props }, ref) => (
  <GradientText
    ref={ref}
    as="h4"
    className={cn("text-xl", className)}
    {...props}
  />
))
GradientH4.displayName = "GradientH4"

export { GradientText, GradientH1, GradientH2, GradientH3, GradientH4 }
